import React, { useRef } from 'react';
import { Upload, X, Paperclip } from 'lucide-react';
import { toast } from 'sonner';

export const MAX_FILE_SIZE_MB = 25;
const BYTES_PER_KB = 1024;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * BYTES_PER_KB * BYTES_PER_KB;

export const FileUploadField = ({ files, setFiles }) => {
  const fileInputRef = useRef(null);

  const handleFiles = (e) => {
    const newFiles = Array.from(e.target.files).filter((f) => {
      if (f.size > MAX_FILE_SIZE_BYTES) {
        toast.error(`${f.name} is too large (max ${MAX_FILE_SIZE_MB}MB)`);
        return false;
      }
      return true;
    });
    setFiles((prev) => [...prev, ...newFiles]);
    e.target.value = '';
  };

  const removeFile = (index) => setFiles(files.filter((_, i) => i !== index));

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2">Upload Files (logos, photos, documents — anything)</label>
      <button
        type="button"
        data-testid="upload-files-button"
        onClick={() => fileInputRef.current?.click()}
        className="w-full border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-[#7B1E2B] hover:bg-[#7B1E2B]/5 transition-colors"
      >
        <Upload className="h-8 w-8 text-gray-400 mx-auto mb-2" />
        <p className="text-sm text-gray-600 font-medium">Click to choose files</p>
        <p className="text-xs text-gray-400 mt-1">Any file type, up to {MAX_FILE_SIZE_MB}MB each</p>
      </button>
      <input ref={fileInputRef} type="file" multiple onChange={handleFiles} className="hidden" data-testid="file-input" />

      {files.length > 0 && (
        <ul className="mt-3 space-y-2" data-testid="selected-files-list">
          {files.map((f, i) => (
            <li key={`${f.name}-${f.size}-${f.lastModified}`} className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-md px-3 py-2">
              <span className="flex items-center gap-2 text-sm text-gray-700 truncate">
                <Paperclip className="h-4 w-4 text-gray-400 shrink-0" />
                {f.name}
                <span className="text-xs text-gray-400">({(f.size / BYTES_PER_KB).toFixed(0)} KB)</span>
              </span>
              <button type="button" onClick={() => removeFile(i)} aria-label={`Remove ${f.name}`} className="text-gray-400 hover:text-red-600">
                <X className="h-4 w-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
